import {radialProgressiveBlur} from '@remotion/effects/radial-progressive-blur';
import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	HtmlInCanvas,
	interpolate,
	useCurrentFrame,
} from 'remotion';
import {CloseUpFrame} from './CloseUpFrame';

const CloseUp1Content = () => {
	const frame = useCurrentFrame();
	const captureFrame = frame + 444;

	return (
		<HtmlInCanvas
			width={3214}
			height={1690}
			style={{
				translate: '-852px -905.8px',
				scale: 1.26,
				rotate: interpolate(
					frame,
					[0, 53],
					[
						'0.972701 -0.216303 -0.084055 31.026846deg',
						'0.975602 -0.204577 -0.079683 29.737284deg',
					],
					{
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				),
			}}
			effects={[
				radialProgressiveBlur({
					center: [0.586, 0.829],
					height: 0.89,
					width: 0.861,
					rotation: -9.5,
					start: 0.384,
					endBlur: 21,
				}),
			]}
		>
			<AbsoluteFill name="Canvas Capture" style={{}} from={-444}>
				<Video
					src="https://remotion.media/studio-close-ups/studio-timeline-editing.mp4"
					style={{
						position: 'absolute',
					}}
				/>
				<MacOSCursor
					cursor={interpolate(
						captureFrame,
						[
							105, 131, 226, 234, 235, 276, 280, 317, 325, 380, 382, 424, 554,
							630, 640, 641, 679,
						],
						[
							'auto',
							'ew-resize',
							'auto',
							'ew-resize',
							'auto',
							'ew-resize',
							'auto',
							'ew-resize',
							'auto',
							'ew-resize',
							'auto',
							'ew-resize',
							'ew-resize',
							'auto',
							'ew-resize',
							'auto',
							'ew-resize',
						],
						{
							easing: [
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
							],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					)}
					style={{
						position: 'absolute',
						left: 0,
						top: 0,
						scale: interpolate(
							captureFrame,
							[0, 154, 210, 438, 441, 483, 486, 575, 616, 700, 781],
							[4, 3.6, 4, 4, 3.6, 3.6, 4, 3.6, 4, 3.6, 4],
							{
								easing: [
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.spring({
										damping: 200,
										mass: 1,
										stiffness: 100,
										allowTail: true,
										durationRestThreshold: 0.02,
										overshootClamping: false,
									}),
									Easing.step1,
									Easing.spring({
										damping: 200,
										mass: 1,
										stiffness: 100,
										allowTail: true,
										durationRestThreshold: 0.02,
										overshootClamping: false,
									}),
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
								],
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
						translate: interpolate(
							captureFrame,
							[
								105, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119,
								120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132,
								133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 168, 169,
								170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182,
								183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195,
								196, 197, 198, 199, 200, 201, 203, 204, 224, 225, 226, 227, 228,
								229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241,
								242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254,
								255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267,
								268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280,
								281, 282, 283, 284, 302, 303, 305, 306, 307, 310, 311, 312, 313,
								316, 317, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329,
								330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342,
								343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 359, 360,
								361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373,
								374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386,
								396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408,
								409, 410, 412, 413, 415, 416, 419, 420, 423, 424, 425, 426, 427,
								428, 429, 430, 431, 432, 433, 434, 435, 453, 454, 455, 456, 457,
								458, 459, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469, 470,
								471, 472, 473, 474, 477, 589, 590, 591, 592, 593, 594, 595, 596,
								597, 598, 599, 600, 601, 602, 603, 604, 605, 606, 607, 608, 609,
								610, 611, 612, 629, 630, 631, 632, 633, 634, 635, 636, 637, 638,
								639, 640, 641, 642, 643, 644, 645, 646, 647, 648, 649, 650, 651,
								652, 653, 654, 655, 656, 657, 658, 659, 660, 661, 662, 663, 664,
								665, 666, 667, 668, 669, 670, 671, 672, 673, 674, 675, 676, 677,
								678, 679, 680, 681, 682, 683, 684, 685, 686, 687, 688, 689, 690,
								715, 716, 717, 718, 719, 720, 721, 722, 723, 724, 725, 726, 727,
								728, 729, 730, 731, 732, 733, 734, 735, 736, 737, 738, 739, 740,
								741, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 752, 753,
								754, 755, 756, 757, 758, 759, 760, 761, 762, 763, 767, 768,
							],
							[
								'1793.140625px 1222.859375px',
								'1793.140625px 1222.859375px',
								'1799.328125px 1222.859375px',
								'1807.34375px 1224.375px',
								'1810.375px 1225.890625px',
								'1810.375px 1225.890625px',
								'1810.375px 1231.34375px',
								'1811.890625px 1237.0625px',
								'1815.5px 1242.78125px',
								'1817.59375px 1255px',
								'1819.6875px 1263.40625px',
								'1821.78125px 1271.8125px',
								'1825.96875px 1280.21875px',
								'1825.96875px 1285.9375px',
								'1827.484375px 1291.65625px',
								'1827.484375px 1297.375px',
								'1827.484375px 1303.09375px',
								'1827.484375px 1311.5px',
								'1827.484375px 1317.21875px',
								'1829.578125px 1322.9375px',
								'1831.09375px 1328.65625px',
								'1833.1875px 1337.0625px',
								'1834.703125px 1342.78125px',
								'1836.796875px 1351.1875px',
								'1843.078125px 1365.3125px',
								'1844.59375px 1371.03125px',
								'1846.109375px 1374.0625px',
								'1846.109375px 1379.78125px',
								'1847.625px 1382.8125px',
								'1849.140625px 1385.84375px',
								'1849.140625px 1388.875px',
								'1850.65625px 1391.90625px',
								'1852.171875px 1393.421875px',
								'1852.171875px 1396.1875px',
								'1853.6875px 1396.1875px',
								'1853.6875px 1397.4375px',
								'1854.9375px 1397.4375px',
								'1854.9375px 1397.4375px',
								'1852.078125px 1397.4375px',
								'1845.0625px 1397.4375px',
								'1835.828125px 1397.4375px',
								'1823.546875px 1397.4375px',
								'1805.171875px 1397.4375px',
								'1797.296875px 1397.4375px',
								'1783.671875px 1398.40625px',
								'1773.21875px 1399.859375px',
								'1766.640625px 1401.84375px',
								'1762.9375px 1402.125px',
								'1752.484375px 1404.609375px',
								'1741.71875px 1406.078125px',
								'1733.65625px 1407.453125px',
								'1723.21875px 1408.796875px',
								'1709.0625px 1410.125px',
								'1700.09375px 1410.90625px',
								'1689.40625px 1411.984375px',
								'1680.21875px 1412.140625px',
								'1673.75px 1412.15625px',
								'1665.390625px 1412.15625px',
								'1656.703125px 1414.046875px',
								'1647.953125px 1414.203125px',
								'1639.203125px 1414.203125px',
								'1630.578125px 1414.203125px',
								'1622.140625px 1414.203125px',
								'1617.734375px 1414.203125px',
								'1615.3125px 1414.203125px',
								'1615.3125px 1414.203125px',
								'1613.75px 1414.203125px',
								'1613.75px 1414.203125px',
								'1612.859375px 1414.71875px',
								'1612.859375px 1414.71875px',
								'1612.203125px 1415.265625px',
								'1612.203125px 1415.265625px',
								'1611.109375px 1415.28125px',
								'1611.109375px 1415.28125px',
								'1605.90625px 1415.28125px',
								'1571.390625px 1399.9375px',
								'1509.890625px 1376.09375px',
								'1439.890625px 1351.09375px',
								'1385.71875px 1332.25px',
								'1288.015625px 1307.796875px',
								'1235.015625px 1294.53125px',
								'1173.515625px 1280.109375px',
								'1134px 1272.421875px',
								'1099px 1262.421875px',
								'1085.984375px 1259.15625px',
								'1032.984375px 1250.3125px',
								'974.296875px 1238.78125px',
								'942.109375px 1231.671875px',
								'921.0625px 1225.71875px',
								'905px 1223.03125px',
								'883.953125px 1213.828125px',
								'867.890625px 1208.453125px',
								'851.828125px 1203.078125px',
								'835.765625px 1200.390625px',
								'819.703125px 1197.703125px',
								'807.453125px 1195.015625px',
								'791.390625px 1192.328125px',
								'775.328125px 1189.640625px',
								'759.265625px 1186.953125px',
								'747.015625px 1184.265625px',
								'738.578125px 1184.265625px',
								'730.140625px 1182.15625px',
								'721.703125px 1180.046875px',
								'715.953125px 1178.515625px',
								'710.203125px 1176.40625px',
								'704.453125px 1174.296875px',
								'694.484375px 1170.65625px',
								'688.734375px 1168.546875px',
								'680.296875px 1166.4375px',
								'674.546875px 1162.796875px',
								'668.796875px 1161.265625px',
								'660.359375px 1159.15625px',
								'654.609375px 1157.046875px',
								'646.171875px 1152.828125px',
								'633.921875px 1150.71875px',
								'628.171875px 1148.609375px',
								'619.734375px 1146.5px',
								'616.671875px 1144.96875px',
								'612.453125px 1143.4375px',
								'609.390625px 1143.4375px',
								'606.328125px 1143.4375px',
								'603.265625px 1141.90625px',
								'600.203125px 1141.90625px',
								'597.140625px 1140.375px',
								'594.078125px 1138.84375px',
								'588.328125px 1137.3125px',
								'582.578125px 1135.78125px',
								'574.140625px 1133.671875px',
								'568.390625px 1130.03125px',
								'563.796875px 1128.5px',
								'560.734375px 1126.96875px',
								'560.734375px 1125.4375px',
								'559.46875px 1125.4375px',
								'557.9375px 1124.171875px',
								'557.9375px 1124.171875px',
								'558.90625px 1124.171875px',
								'558.90625px 1124.171875px',
								'559.96875px 1124.171875px',
								'561.0625px 1124.171875px',
								'561.0625px 1124.171875px',
								'562.09375px 1124.171875px',
								'562.09375px 1124.171875px',
								'563.15625px 1124.171875px',
								'563.15625px 1124.171875px',
								'564.1875px 1124.171875px',
								'564.1875px 1124.171875px',
								'565.234375px 1124.171875px',
								'565.234375px 1124.171875px',
								'566.296875px 1124.171875px',
								'567.8125px 1124.171875px',
								'577.734375px 1124.171875px',
								'593.765625px 1124.171875px',
								'614.78125px 1124.171875px',
								'640.78125px 1127.421875px',
								'661.796875px 1127.421875px',
								'677.828125px 1127.421875px',
								'686.234375px 1129.515625px',
								'691.953125px 1131.03125px',
								'697.671875px 1131.03125px',
								'703.390625px 1132.546875px',
								'715.609375px 1137.3125px',
								'736.625px 1143.234375px',
								'782.265625px 1151.46875px',
								'852.234375px 1166.4375px',
								'931.90625px 1187.59375px',
								'1032.171875px 1211.109375px',
								'1121.546875px 1239.03125px',
								'1175.6875px 1256.671875px',
								'1228.65625px 1269.90625px',
								'1279.96875px 1287.890625px',
								'1305.96875px 1297.640625px',
								'1345.453125px 1312.96875px',
								'1377.609375px 1330.953125px',
								'1415.921875px 1350.09375px',
								'1431.25px 1361.578125px',
								'1452.265625px 1373.421875px',
								'1460.671875px 1381.828125px',
								'1463.703125px 1384.859375px',
								'1466.734375px 1387.890625px',
								'1466.734375px 1389.40625px',
								'1466.734375px 1389.40625px',
								'1471.921875px 1389.40625px',
								'1487.953125px 1389.40625px',
								'1503.984375px 1389.40625px',
								'1520.015625px 1389.40625px',
								'1525.734375px 1389.40625px',
								'1531.453125px 1389.40625px',
								'1534.484375px 1389.40625px',
								'1534.484375px 1389.40625px',
								'1535.578125px 1389.40625px',
								'1535.578125px 1389.40625px',
								'1538.234375px 1389.40625px',
								'1539.75px 1389.40625px',
								'1542.515625px 1389.40625px',
								'1544.03125px 1389.40625px',
								'1546.796875px 1389.40625px',
								'1549.828125px 1389.40625px',
								'1552.859375px 1389.40625px',
								'1561.265625px 1391.5px',
								'1573.484375px 1394.171875px',
								'1589.515625px 1399.515625px',
								'1605.546875px 1402.1875px',
								'1621.578125px 1404.859375px',
								'1633.796875px 1407.53125px',
								'1639.515625px 1407.53125px',
								'1645.234375px 1407.53125px',
								'1648.265625px 1407.53125px',
								'1649.515625px 1407.53125px',
								'1649.515625px 1407.53125px',
								'1648.515625px 1407.53125px',
								'1646.984375px 1407.53125px',
								'1644.1875px 1407.53125px',
								'1642.921875px 1407.53125px',
								'1641.671875px 1407.53125px',
								'1641.671875px 1407.53125px',
								'1639.25px 1407.53125px',
								'1636.1875px 1407.53125px',
								'1633.125px 1407.53125px',
								'1633.125px 1407.53125px',
								'1630.328125px 1407.53125px',
								'1629.171875px 1407.53125px',
								'1629.171875px 1407.53125px',
								'1628.015625px 1407.53125px',
								'1628.015625px 1407.53125px',
								'1626.953125px 1407.53125px',
								'1626.953125px 1407.53125px',
								'1625.90625px 1407.53125px',
								'1625.90625px 1407.53125px',
								'1624.859375px 1407.53125px',
								'1624.859375px 1407.53125px',
								'1623.8125px 1407.53125px',
								'1622.65625px 1407.53125px',
								'1621.5px 1407.53125px',
								'1621.5px 1407.53125px',
								'1620.390625px 1407.53125px',
								'1620.390625px 1407.53125px',
								'1619.234375px 1407.53125px',
								'1619.234375px 1407.53125px',
								'1618.15625px 1407.53125px',
								'1618.15625px 1407.53125px',
								'1618.15625px 1406.375px',
								'1617px 1406.375px',
								'1617px 1406.375px',
								'1626.296875px 1406.375px',
								'1652.1875px 1406.375px',
								'1663.28125px 1406.375px',
								'1679.515625px 1406.375px',
								'1745.640625px 1406.375px',
								'1759.234375px 1406.375px',
								'1775.3125px 1406.375px',
								'1825.078125px 1406.375px',
								'1845.765625px 1406.375px',
								'1858.765625px 1406.375px',
								'1865.75px 1406.375px',
								'1871.765625px 1406.375px',
								'1878.96875px 1406.375px',
								'1886.296875px 1406.375px',
								'1892.203125px 1406.375px',
								'1895.28125px 1406.375px',
								'1898.3125px 1406.375px',
								'1898.3125px 1406.375px',
								'1900.640625px 1406.375px',
								'1901.84375px 1406.375px',
								'1903.234375px 1406.375px',
								'1905.90625px 1406.375px',
								'1894.515625px 1400.140625px',
								'1890.3125px 1400.140625px',
								'1875.671875px 1400.140625px',
								'1856.90625px 1400.140625px',
								'1843.8125px 1400.140625px',
								'1797.59375px 1400.140625px',
								'1783.890625px 1400.140625px',
								'1757.5625px 1400.140625px',
								'1725.96875px 1400.140625px',
								'1708.0625px 1400.140625px',
								'1697.4375px 1400.140625px',
								'1674.3125px 1400.140625px',
								'1651.890625px 1400.140625px',
								'1641.1875px 1400.140625px',
								'1612.53125px 1400.140625px',
								'1603.5625px 1400.140625px',
								'1581.125px 1400.140625px',
								'1573.8125px 1400.140625px',
								'1570.703125px 1400.140625px',
								'1566.421875px 1400.140625px',
								'1566.421875px 1400.140625px',
								'1563.75px 1400.140625px',
								'1563.75px 1400.140625px',
								'1562.4375px 1400.140625px',
								'1562.4375px 1400.140625px',
								'1548.4375px 1400.140625px',
								'1521.9375px 1400.140625px',
								'1489.75px 1396.296875px',
								'1444.078125px 1388.03125px',
								'1398.40625px 1375.9375px',
								'1360.0625px 1364.421875px',
								'1305.890625px 1350.578125px',
								'1260.21875px 1334.0625px',
								'1221.875px 1326.375px',
								'1168.875px 1317.53125px',
								'1096.703125px 1300.421875px',
								'1058.359375px 1292.734375px',
								'1007px 1278.53125px',
								'987.828125px 1274.6875px',
								'966.78125px 1268.734375px',
								'940.75px 1262.203125px',
								'919.703125px 1259.515625px',
								'893.671875px 1252.984375px',
								'872.625px 1247.03125px',
								'843.546875px 1241.078125px',
								'826.3125px 1235.703125px',
								'814.0625px 1233.59375px',
								'801.8125px 1231.484375px',
								'793.375px 1227.265625px',
								'777.3125px 1224.578125px',
								'765.0625px 1217.671875px',
								'752.8125px 1214.984375px',
								'740.5625px 1210.1875px',
								'728.3125px 1205.390625px',
								'716.0625px 1200.59375px',
								'703.8125px 1195.796875px',
								'687.75px 1190.421875px',
								'675.5px 1185.625px',
								'659.4375px 1182.9375px',
								'643.375px 1174.890625px',
								'631.125px 1172.78125px',
								'622.6875px 1168.5625px',
								'616.9375px 1164.921875px',
								'611.1875px 1163.390625px',
								'605.4375px 1159.75px',
								'602.375px 1158.21875px',
								'599.3125px 1156.6875px',
								'598.046875px 1155.421875px',
								'595.25px 1154.15625px',
								'593.71875px 1152.625px',
								'592.453125px 1151.359375px',
								'592.453125px 1150.203125px',
								'592.453125px 1150.203125px',
								'591.296875px 1148.671875px',
								'589.765625px 1148.671875px',
								'588.5px 1147.40625px',
								'587.234375px 1144.609375px',
								'585.703125px 1143.078125px',
								'584.171875px 1141.546875px',
								'582.640625px 1140.015625px',
								'581.375px 1138.75px',
								'579.84375px 1137.484375px',
								'579.84375px 1137.484375px',
								'578.3125px 1136.328125px',
								'578.3125px 1136.328125px',
								'578.3125px 1135.21875px',
								'578.3125px 1135.21875px',
								'579.796875px 1135.21875px',
								'587.3125px 1135.21875px',
								'601.046875px 1135.21875px',
								'615.515625px 1135.21875px',
								'631.953125px 1135.21875px',
								'631.953125px 1135.21875px',
								'653.15625px 1135.21875px',
								'663.8125px 1135.21875px',
								'668.03125px 1135.21875px',
								'680.640625px 1135.21875px',
								'691.265625px 1135.21875px',
								'698.65625px 1135.21875px',
								'705.765625px 1135.21875px',
								'710.875px 1135.21875px',
								'716.671875px 1135.21875px',
								'720.15625px 1135.21875px',
								'721.734375px 1135.21875px',
								'726.5px 1135.21875px',
								'732.265625px 1135.21875px',
								'735.296875px 1135.21875px',
								'738.015625px 1135.21875px',
								'739.234375px 1135.21875px',
								'742.03125px 1135.21875px',
								'745.125px 1135.21875px',
								'748.0625px 1135.21875px',
								'751.203125px 1135.21875px',
								'754.359375px 1135.21875px',
								'755.9375px 1135.21875px',
								'759.078125px 1135.21875px',
								'762.140625px 1135.21875px',
								'767.859375px 1135.21875px',
								'773.265625px 1135.21875px',
								'778.9375px 1135.21875px',
								'784.9375px 1135.21875px',
								'790.921875px 1135.21875px',
								'795.703125px 1135.21875px',
								'801.53125px 1135.21875px',
								'808.59375px 1135.21875px',
								'814.671875px 1135.21875px',
								'819.234375px 1135.21875px',
								'823.828125px 1135.21875px',
								'830.40625px 1135.21875px',
								'833.390625px 1135.21875px',
								'836.515625px 1135.21875px',
								'839.65625px 1135.21875px',
								'842.8125px 1135.21875px',
								'842.8125px 1135.21875px',
								'844.34375px 1135.21875px',
								'844.34375px 1135.21875px',
								'845.59375px 1135.21875px',
							],
							{
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
					}}
				/>
			</AbsoluteFill>
		</HtmlInCanvas>
	);
};

export const CloseUp1Preview = () => {
	return (
		<CloseUpFrame>
			<CloseUp1Content />
		</CloseUpFrame>
	);
};

export const CloseUp1 = () => {
	return (
		<Composition
			id="TrimClip"
			component={CloseUp1Preview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={54}
		/>
	);
};
